/** @format */
import { TraceAnalysisSearchProps, FilterMtchProps, TraceAnalysisDetailSpan } from './typescript'

/** Span 属性筛选单行初始值 */
export const emptySpanValue = (): FilterMtchProps => ({
  Key: '',
  Op: 'in',
  Values: []
})

/** Span 属性筛选初始列表（至少一行便于录入） */
export const initSpanAttributeFilters: FilterMtchProps[] = [emptySpanValue()]

export const initTraceAnalysisSearch: TraceAnalysisSearchProps = {
  Page: 1,
  PageSize: 20,
  Order: '',
  OrderBy: '',
  Filters: []
}

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value))

/** HSL(0–360, 0–1, 0–1) → #rrggbb */
const hslToHex = (h: number, s: number, l: number): string => {
  const hue = ((h % 360) + 360) % 360
  const sat = clamp(s, 0, 1)
  const light = clamp(l, 0, 1)
  const c = (1 - Math.abs(2 * light - 1)) * sat
  const x = c * (1 - Math.abs(((hue / 60) % 2) - 1))
  const m = light - c / 2
  let r = 0
  let g = 0
  let b = 0
  if (hue < 60) {
    r = c
    g = x
  } else if (hue < 120) {
    r = x
    g = c
  } else if (hue < 180) {
    g = c
    b = x
  } else if (hue < 240) {
    g = x
    b = c
  } else if (hue < 300) {
    r = x
    b = c
  } else {
    r = c
    b = x
  }
  const toHex = (channel: number) =>
    Math.round((channel + m) * 255)
      .toString(16)
      .padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

/** 根据服务名生成稳定色值，用于 Tag 与拓扑节点边框 */
export const ServiceToColor = (serviceName: string) => {
  if (!serviceName) return '#94a3b8'

  let hash = 0
  for (let i = 0; i < serviceName.length; i++) {
    hash = serviceName.charCodeAt(i) + ((hash << 5) - hash)
  }
  hash = Math.abs(hash)

  const hue = hash % 360
  // 中等饱和度 + 偏暗明度，白底上 2px 描边与 Tag 都更清晰
  const saturation = 0.5 + ((hash >> 8) % 16) / 100 // 50%–65%
  const lightness = 0.36 + ((hash >> 4) % 12) / 100 // 36%–47%

  return hslToHex(hue, saturation, lightness)
}

/** 将接口返回的嵌套 Spans 展平为列表，供按 ParentSpanId 构建树表 */
export function flattenTraceDetailSpans(
  spans: TraceAnalysisDetailSpan[]
): TraceAnalysisDetailSpan[] {
  const result: TraceAnalysisDetailSpan[] = []

  const walk = (list: TraceAnalysisDetailSpan[]) => {
    for (const span of list) {
      const { Children, ...rest } = span
      const serviceName = rest.Resource?.['service.name']
      result.push({
        ...rest,
        ServiceName: serviceName,
        BgColor: ServiceToColor(serviceName)
      })
      if (Children?.length) {
        walk(Children)
      }
    }
  }

  walk(spans)
  return result
}
